import React from 'react';
import { View, Modal } from 'react-native';
import { translate } from '../services/translate';
import MyAppText from './MyAppText';
import { createStyleSheet, useStyles } from 'react-native-unistyles';
import CustomButton, { ButtonTypes } from './CustomButton';
import { WindowInformation } from '../services/window-information';


interface ModalProps {
    isModalVisible: boolean;
    setModalVisible: (value: boolean) => void;
    onSubmit: () => void;
    onCancel?: () => void;
    itemName?: string;
    customMessage?: string;
    customConfirm?: string;
    onSubmitType?: ButtonTypes;
    isLoading?: boolean;
    maxWidth?: number;
}

export default function ConfirmModal({
    isModalVisible,
    setModalVisible,
    onSubmit,
    onCancel,
    itemName,
    customMessage,
    customConfirm,
    onSubmitType,
    isLoading,
    maxWidth,
}: ModalProps) {
    const { styles } = useStyles(styleSheet);
    const windowInfo = WindowInformation();

    if (!onSubmitType) {
        onSubmitType = 'primary';
    }

    return (
        <Modal
            visible={isModalVisible}
            animationType='fade'
            onRequestClose={() => {
                onCancel && onCancel();
                setModalVisible(false);
            }}
            transparent={true}
        >
            <View style={styles.container}>
                <View style={styles.body(windowInfo.isMobile, maxWidth)}>
                    <MyAppText style={styles.confirmationText}>{customMessage ?? (itemName ? `${translate('confirm_action')}: ${itemName}` : `${translate('confirm_action')}?`)}</MyAppText>
                    <View style={styles.confirmButtonsView}>
                        <CustomButton
                            onPress={() => {
                                onCancel && onCancel();
                                setModalVisible(false);
                            }}
                            text={translate('no')}
                            type='secondary' />
                        <CustomButton
                            onPress={() => {
                                onSubmit();
                                setModalVisible(false);
                            }}
                            isLoading={isLoading}
                            type={onSubmitType}
                            text={customConfirm ?? translate('yes')} />
                    </View>
                </View>
            </View>
        </Modal>
    );
}

const styleSheet = createStyleSheet((theme) => ({
    container: {
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: '#31313199',
        flex: 1
    },
    body: (isMobile: boolean, maxWidth?: number) => ({
        width: isMobile ? '95%' : '80%',
        maxWidth: maxWidth,
        backgroundColor: theme.colors.card.background,
        flexDirection: 'column',
        borderRadius: 4,
        padding: 25,
        rowGap: 20,
    }),
    headerText: {
        fontSize: 20,
    },
    buttonsView: {
        flexDirection: 'row',
        alignItems: 'center',
        flexWrap: 'wrap',
        justifyContent: 'flex-end',
        gap: 20
    },
    confirmationText: {
        fontSize: 20,
    },
    confirmButtonsView: {
        flexDirection: 'row',
        alignItems: 'center',
        flexWrap: 'wrap',
        justifyContent: 'space-between',
    }
}));
